import * as React from "react";
import Box from "@mui/material/Box";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import Button from "@mui/material/Button";
// import Divider from "@mui/material/Divider";
// import List from "@mui/material/List";
// import ListItem from "@mui/material/ListItem";
// import ListItemButton from "@mui/material/ListItemButton";
// import ListItemIcon from "@mui/material/ListItemIcon";
// import ListItemText from "@mui/material/ListItemText";
// import InboxIcon from "@mui/icons-material/MoveToInbox";
// import MailIcon from "@mui/icons-material/Mail";
// import { domain } from "../../constants/generalConstant";
import { Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
// import HeaderAccordian from "./HeaderAccordian";
// import { Link } from "react-router-dom";
import ShipTrackTab from "./ShipTrackTab";

export default function HeaderDrawer() {
  const [drawerOpen, setDrawerOpen] = React.useState(false);

  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

  const list = () => (
    <Box
      sx={{
        minWidth: "60vw",
        minHeight: "7rem",
      }}
      role="presentation"
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "0.5rem",
          bgcolor: "#FDF9EC",
        }}
      >
        <Typography sx={{ fontSize: "0.9rem", p: "0.3", fontWeight: "400" }}>
          <span className="animate-pulse"> Shippers route Logistics</span>
        </Typography>
        <IconButton onClick={toggleDrawer(false)} aria-label="close drawer">
          <span className="text-[0.9rem]  font-bold">close</span>
          <CloseIcon />
        </IconButton>
      </Box>
      {/* <List>
				{["Inbox", "Starred", "Send email", "Drafts"].map((text, index) => (
					<ListItem key={text} disablePadding>
						<ListItemButton>
							<ListItemIcon>
								{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
							</ListItemIcon>
							<ListItemText primary={text} />
						</ListItemButton>
					</ListItem>
				))}
			</List> */}
      {/* <Link
				style={{
					color: "black",
					textDecoration: "none",
					fontSize: "1.2rem",
					margin: "0.8rem",
				}}
				to="/">
				Tracking
			</Link> */}

      <ShipTrackTab toggleDrawer={toggleDrawer} />
      {/* <Divider />

			<HeaderAccordian />

			<Divider />
			<List>
				{["All mail", "Trash", "Spam"].map((text, index) => (
					<ListItem key={text} disablePadding>
						<ListItemButton>
							<ListItemIcon>
								{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
							</ListItemIcon>
							<ListItemText primary={text} />
						</ListItemButton>
					</ListItem>
				))}
			</List> */}
    </Box>
  );

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
      }}
    >
      <Button
        onClick={toggleDrawer(true)}
        sx={{ color: "white", fontSize: "1.2rem", fontWeight: "light" }}
      >
        <MenuIcon />
      </Button>
      <SwipeableDrawer
        anchor="right"
        open={drawerOpen}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
      >
        {list()}
      </SwipeableDrawer>
    </div>
  );
}
